module.exports = __webpack_public_path__ + "static/media/BrixSans-Light-Italic.4885bb62.woff2";